import { SettingsActionBar } from '../../components/settings/primitives';
import { useSettingsDraft } from './SettingsDraftContext';

/** The shared save/discard bar, bound to the settings draft for the open section. */
const SettingsDraftActionBar = () => {
    const { isDirty, isSaving, save, discard } = useSettingsDraft();

    return (
        <SettingsActionBar
            isDirty={isDirty}
            isSaving={isSaving}
            onSave={save}
            onDiscard={discard}
        />
    );
};

export default SettingsDraftActionBar;
